import jq from 'jquery';
import M from 'materialize-css';

function onWaitForSelectChange( url, wanted, select_element ) {

    window.axios.post( url+wanted.val() )
        .then( response => {

            while (select_element.firstChild) {
                select_element.removeChild(select_element.firstChild);
            }

            for (let i = 0; i < response.data.length; i++) {
                let op = document.createElement('option');
                op.text = response.data[i].text;
                op.value = response.data[i].value;
                select_element.appendChild(op);
            }
            select_element.classList.remove('browser-default');
            if (select_element.classList.contains('search')) {
                jq(select_element).select2({
                    theme: 'material'
                });
            } else {
                M.FormSelect.init(select_element, {})
            }

        })
        .catch( error => {
            console.log('Error on waitfor module script', error);
        })
}

function initWaitFor() {
    let waitfors = document.getElementsByClassName('asd-waitfor');
    for (let i=0; i< waitfors.length; i++) {
        let x = waitfors[i];
        let target = x.getAttribute('target',null);
        let url = x.getAttribute('target-url',null);
        //let field = x.getAttribute('target-field',null);

        let wanted = jq('#'+target);

        jq(wanted).change( () => {
            onWaitForSelectChange(url, wanted, x);
        });
    }
}

export default initWaitFor;